import { Loader } from "components/Loader/Loader.component";
import { useDefaultObservableBoolean } from "observables/BooleanObservable";
import { useTranslation } from "react-i18next";
import { rewardDetailsPageService } from "service/shared/singletones/rewardDetailsPageService/rewardDetailsPage.service";
import { createComponent } from "utils/libExtend/createComponent";

import { RewardDetailsInformationContent } from "./RewardDetailsInformationContent/RewardDetailsInformationContent.component";
import { SRewardDetailsInformation } from "./RewardDetailsInformationStyled/SRewardDetailsInformation.styled";
import { SRewardDetailsInformationContainer } from "./RewardDetailsInformationStyled/SRewardDetailsInformationContainer.styled";
import { SRewardDetailsInformationLoader } from "./RewardDetailsInformationStyled/SRewardDetailsInformationLoader.styled";

export const RewardDetailsInformation = createComponent("RewardDetailsInformation", () => {
  const { i18n } = useTranslation();
  const loaded = useDefaultObservableBoolean(rewardDetailsPageService.state.loaded);

  return (
    <SRewardDetailsInformation>
      <SRewardDetailsInformationContainer isArabic={i18n.language === "ar"}>
        {loaded ? (
          <RewardDetailsInformationContent />
        ) : (
          <SRewardDetailsInformationLoader>
            <Loader />
          </SRewardDetailsInformationLoader>
        )}
      </SRewardDetailsInformationContainer>
    </SRewardDetailsInformation>
  );
});
